var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconBookmark01 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M3.85 2a.5.5 0 0 0-.5.5v10.103a.5.5 0 0 0 .763.425l3.622-2.24a.5.5 0 0 1 .529.003l3.551 2.228a.5.5 0 0 0 .766-.423V2.5a.5.5 0 0 0-.5-.5zm5.105 3.435L8 3.5l-.955 1.935-2.136.31 1.546 1.507L6.09 9.38 8 8.375l1.91 1.004-.365-2.127 1.546-1.506z",
  clipRule: "evenodd"
})));
export default SvgIconBookmark01;